
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Inject,
  signal,
  ViewEncapsulation,
  WritableSignal,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { ISelectedDate } from '@app/shared/models/header-search-model';
import { MAX_DRILL_DOWN_DAYS } from '@app/shared/utils/layout-util';
import { LayoutServiceService } from '@layout/services/layout/layout-service.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-error-message',
  standalone: true,
  imports: [MatDialogModule, MatDividerModule, TranslateModule],
  templateUrl: './error-message.component.html',
  styleUrl: './error-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ErrorMessageComponent {
  layoutService = inject(LayoutServiceService);
  drillDownDateRange: WritableSignal<ISelectedDate> = signal<ISelectedDate>(
    {} as ISelectedDate,
  );
  maxDays = MAX_DRILL_DOWN_DAYS;

  constructor(@Inject(MAT_DIALOG_DATA) protected errorMessage: string) {
    this.drillDownDateRange.set(this.layoutService.getDrillDownDateRange());
  }
}
